import { TFunction } from 'i18next';
import { CopilotAction } from 'models/copilot/copilotAction';
import { TenantProcess } from 'models/copilot/tenantProcessStateBase';

export const getCopilotProcessWelcomeMessage = (action: CopilotAction, t: TFunction<string[]>): string | undefined => {
  switch (action.processId) {
    case TenantProcess.AnnualPlan:
      return t('copilot:Processes.AnnualPlan.Welcome');
    case TenantProcess.Library:
      return t('copilot:Processes.Library.Welcome');
    case TenantProcess.ProcessSuggestions:
      return t('copilot:Processes.ProcessSuggestions.Welcome');
    case TenantProcess.ControlEvidenceAudit:
      return t('copilot:Processes.ControlEvidenceAudit.Welcome');
    case TenantProcess.ControlDocumentationAudit:
      return t('copilot:Processes.ControlDocumentationAudit.Welcome');
    case TenantProcess.TaskEvidenceAudit:
      return t('copilot:Processes.TaskEvidenceAudit.Welcome');
    case TenantProcess.AuditFindings:
      return t('copilot:Processes.AuditFindings.Welcome');
    case TenantProcess.FrameworkAudit:
      return t('copilot:Processes.FrameworkAudit.Welcome');
    case TenantProcess.AutomationDrafting:
      return t('copilot:Processes.AutomationDrafting.Welcome');
    case TenantProcess.KpiReport:
      return t('copilot:Processes.KpiReport.Welcome');
    case TenantProcess.SupplierIncidents:
      return t('copilot:Processes.SupplierIncidents.Welcome');
    case TenantProcess.SupplierCompliance:
      return t('copilot:Processes.SupplierCompliance.Welcome');
    case TenantProcess.EntityEvidenceAudit:
      return t('copilot:Processes.EntityEvidenceAudit.Welcome');
    default:
      return undefined;
  }
};

// The sentence the KPI report process ends with when its File card lands and the thread goes back to the chat (PLAN-070)
export const getKpiReportHandOffMessage = (t: TFunction<string[]>): string => t('copilot:Processes.KpiReport.HandOff');
